<template>
  <div class="dict-picker">
    <div class="header">
      <div class="header-content">
        <div class="back-btn" @click="() => (addLoading ? '' : $emit('prevStep'))">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="search-content" v-if="totalPage > 1">
          <i class="iconfont iconsousuo search-icon-btn" v-show="!showSearch" @click="showSearch = true"></i>
          <el-input
            v-show="showSearch"
            v-model="keyword"
            size="mini"
            prefix-icon="iconfont iconsousuo"
            placeholder="请搜索"
            @input="getDictValHandle"
          />
        </div>
      </div>
      <slot name="header-tips"></slot>
    </div>

    <div class="dict-content" v-loading="dictLoading">
      <div class="dict-empty" v-show="dictList.length < 1">
        <span>当前没有标签分类值</span>
      </div>
      <div
        class="dict-item"
        v-for="(dictVal, dictIndex) in dictList"
        :key="dictIndex"
        :class="dictVal === currentVal ? 'is-active' : ''"
        @click="pickHandle(dictVal)"
      >
        <span>{{ dictVal }}</span>
      </div>
    </div>

    <div class="recommend-word-content" v-loading="addLoading" v-if="isInit && !!recommendWord && !recommendIsSame">
      <div class="word-text single-ellipsis">{{ recommendWord }}</div>
      <div class="add-tip-text">把内容添加为标签分类值</div>
      <div class="add-btn" @click="addFieldCategoryt">
        <i class="el-icon-circle-plus"></i>
      </div>
    </div>

    <div class="bottom-btns">
      <el-button size="mini" @click="$emit('closePopover')">取消</el-button>
      <el-button
        size="mini"
        type="primary"
        :loading="popoverLoading"
        :disabled="!isInit || addLoading || dictList.length < 1"
        @click="nextHandle"
      >
        <span>下一步</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
import { debounce } from 'lodash';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isInit: false,
      keyword: '',
      currentVal: '',
      dictList: [],
      dictLoading: false,
      addLoading: false,
      totalPage: 0,
      recommendIsSame: true,
      showSearch: false
    };
  },
  props: {
    fieldDetail: {
      type: Object,
      required: true
    },
    recommendWord: {
      type: String,
      required: true
    },
    popoverLoading: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getDictValHandle({ isInit: true });
    this.getDictValHandle = debounce(this.getDictValHandle.bind(this), 200);
  },
  methods: {
    pickHandle(dictVal) {
      this.currentVal = dictVal;
      this.nextHandle();
    },
    nextHandle() {
      if (!this.currentVal) {
        this.$message.warning('请选择分类值或者为标签新建一个分类值后再进行标注');
        return;
      }
      this.$emit('next', this.currentVal);
    },
    async getDictValHandle(params) {
      const { isInit = false } = params || {};
      try {
        this.dictLoading = true;
        const { data } = await services.caseRule.getFieldDictVal({
          labelId: this.fieldDetail._id,
          keyword: this.keyword,
          courseId: '',
          recommendWord: this.keyword ? '' : this.recommendWord,
          size: 30
        });
        this.dictList = data.dict_value;
        if (this.totalPage === 0) {
          this.totalPage = data.total_page;
        }
        if (isInit) {
          if (data.isRecommend) {
            this.currentVal = this.dictList[0] || '';
            this.recommendIsSame = this.currentVal === this.recommendWord;
          } else {
            this.recommendIsSame = false;
          }
          this.isInit = true;
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.dictLoading = false;
      }
    },
    async addFieldCategoryt() {
      try {
        this.addLoading = true;
        const { data } = await services.caseRule.getFieldDictVal({
          labelId: this.fieldDetail._id,
          keyword: '',
          courseId: '',
          recommendWord: '',
          size: 10000
        });
        const dictClassifyList = data.dict_classify_value;
        const index = dictClassifyList.findIndex(o => o.labelName === this.recommendWord);

        if (index === -1) {
          dictClassifyList.unshift({ labelName: this.recommendWord, children: '' });
          const params = {
            ...this.fieldDetail,
            ownerId: this.$store.getters.userInfo.id,
            dictValue: dictClassifyList.map(o => o.labelName),
            dictClassifyValue: dictClassifyList,
            update_time: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSSSS')
          };
          delete params._id;
          await services.courseware.updField(this.fieldDetail._id, params);
        }

        this.currentVal = this.recommendWord;
        this.keyword = '';
        this.getDictValHandle({ isInit: true });
        this.nextHandle();
      } catch (err) {
        this.$error(err);
      } finally {
        this.addLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dict-picker {
  .header {
    padding: 8px 14px 0px;
    border-bottom: 1px solid #e8ebef;
    margin-bottom: 5px;

    .header-content {
      position: relative;
      left: -4px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-bottom: 2px;

      .back-btn {
        box-sizing: border-box;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        padding: 0 5px 0 3px;
        color: #3d465a;
        font-size: 14px;
      }

      .search-content {
        .search-icon-btn {
          color: #a0acc0;
          font-size: 14px;
          padding: 4px;
          padding-right: 0;
          cursor: pointer;
        }
      }
    }
  }

  .dict-content {
    box-sizing: border-box;
    padding: 0 14px 5px;
    max-height: 260px;
    overflow-x: hidden;
    overflow-y: auto;

    .dict-empty {
      color: #77839e;
      font-size: 12px;
      line-height: 17px;
      text-align: center;
      margin: 10px 0;
    }

    .dict-item {
      font-size: 14px;
      line-height: 20px;
      word-break: break-all;
      padding: 5px 15px;
      cursor: pointer;

      &:hover {
        background-color: #eaf6ff;
      }

      &.is-active {
        color: #1991fb;
        background-color: #eaf6ff;
      }
    }
  }

  .recommend-word-content {
    position: relative;
    box-sizing: border-box;
    height: 60px;
    background-color: #f8fafd;
    margin: 5px 10px 10px;
    padding: 10px;
    padding-right: 36px;

    .add-tip-text {
      line-height: 20px;
      color: #77839e;
      font-size: 12px;
    }

    .word-text {
      line-height: 20px;
      color: #1991fb;
      font-size: 14px;
    }

    .add-btn {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      padding: 4px;
      color: #1991fb;
      cursor: pointer;
    }
  }

  .bottom-btns {
    text-align: right;
    border-top: 1px solid #e8ebef;
    padding: 11px;
  }
}
</style>
